import { AuthGateway } from "domain/auth/auth.gateway";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppDispatch, RootState } from "domain/store";
import { AuthHttpGateway } from "data/auth/auth-http-gateway";
import { TechniquesGateway } from "domain/techniques/techniques.gateway";
import { TechniquesHttpGateway } from "data/techniques/techniques-http-gateway";
import { SeancesGateway } from "domain/seances/seances.gateway";
import { SeancesHttpGateway } from "data/seances/seances-http-gateway";
import { CarouselGateway } from "domain/carousel/carousel.gateway";
import { CarouselHttpGateway } from "data/carousel/carousel-http-gateway";
import { ActivitiesGateway } from "domain/activities/activities.gateway";
import { ActivitiesHttpGateway } from "data/activities/activities-http-gateway";
import { TutorialsGateway } from "domain/tutorials/tutorials.gateway";
import { TutorialsHttpGateway } from "data/tutorials/tutorials-http-gateway";
import { FoldersGateway } from "domain/folders/folders.gateway";
import { FoldersHttpGateway } from "data/folders/folders-http-gateway";
import { VisualSupportsGateway } from "domain/visual-supports/visual-supports.gateway";
import { VisualSupportsHttpGateway } from "data/visual-supports/visual-supports-http-gateway";
import { AISearchGateway } from "domain/ai-search/ai-search.gateway";
import { AISearchHttpGateway } from "data/ai-search/ai-search-http-gateway";
import { ConsignesGateway } from "./consignes/consignes.gateway";
import { ConsignesHttpGateway } from "data/consignes/consignes-http-gateway";

export type ThunksExtraArgument = {
  authGateway: AuthGateway;
  techniquesGateway: TechniquesGateway;
  seancesGateway: SeancesGateway;
  carouselGateway: CarouselGateway;
  activitiesGateway: ActivitiesGateway;
  tutorialsGateway: TutorialsGateway;
  foldersGateway: FoldersGateway;
  visualSupportsGateway: VisualSupportsGateway;
  aiSearchGateway: AISearchGateway;
  consignesGateway: ConsignesGateway;
};

const authGateway: AuthGateway = new AuthHttpGateway();
const techniquesGateway: TechniquesGateway = new TechniquesHttpGateway();
const seancesGateway: SeancesGateway = new SeancesHttpGateway();
const carouselGateway: CarouselGateway = new CarouselHttpGateway();
const activitiesGateway: ActivitiesGateway = new ActivitiesHttpGateway();
const tutorialsGateway: TutorialsGateway = new TutorialsHttpGateway();
const foldersGateway: FoldersGateway = new FoldersHttpGateway();
const visualSupportsGateway: VisualSupportsGateway =
  new VisualSupportsHttpGateway();
const aiSearchGateway: AISearchGateway = new AISearchHttpGateway();
const consignesGateway: ConsignesGateway = new ConsignesHttpGateway();

export const thunkExtraArgument: ThunksExtraArgument = {
  authGateway,
  techniquesGateway,
  seancesGateway,
  carouselGateway,
  activitiesGateway,
  tutorialsGateway,
  foldersGateway,
  visualSupportsGateway,
  aiSearchGateway,
  consignesGateway,
};

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  extra: ThunksExtraArgument;
}>();
